var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_c('span',[_vm._v("Entregas")])]),_c('v-card-text',{staticClass:"white--text display-1 chart-container"},[_c('apexchart',{attrs:{"type":"donut","height":this.donutHeight,"options":_vm.options,"series":_vm.series}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }